import { Chip } from '@mui/material';
import { differenceInDays, fromUnixTime } from 'date-fns';
import React from 'react';
import { AccessKeyStatus } from 'types/accessKeys';
import { ChipPropsColor } from 'types/common';

interface IAccessKeyStatusChip {
	status?: AccessKeyStatus;
	expireTime?: number;
}

const AccessKeyStatusChip: React.FC<IAccessKeyStatusChip> = ({
	status,
	expireTime
}) => {
	let color: ChipPropsColor = 'error';
	let title = '';

	const today = Date.now();
	const daysDiff = differenceInDays(fromUnixTime(expireTime || 0), today);

	if (daysDiff < 0) {
		color = 'default';
		title = intl.tr('accessKeys.status.cell.expired');
	} else {
		color = status === AccessKeyStatus.active ? 'info' : 'default';
		title = intl.tr(`accessKeys.status.${status}`);
	}

	return (
		<Chip
			label={title}
			title={title}
			variant="outlined"
			size="small"
			color={color}
		/>
	);
};

AccessKeyStatusChip.defaultProps = {
	status: AccessKeyStatus.inactive,
	expireTime: 0
};

export default AccessKeyStatusChip;
